import React from "react"

import * as s from "../../pages/Product.module.scss"

import Layout from "../../components/main/layout/Layout"

import { ProductDescription } from "../../components/main/product-description/ProductDescription"
import { SEO } from "../../components/common/seo/SEO"
import { AnimateWrapper } from "../../components/main/animate-wrapper/AnimateWrapper"
import RecommendedGallery from "../../components/main/shopify-gallery/RecommendedGallery"

const Product = ({ pageContext }) => {
  const { product } = pageContext
  
  if (!product || !product.metafields) {
    console.error("Product or metafields are missing.");
    return null; // Prevents rendering if data is missing
  }

  // Determine if translation should be applied based on the environment
  const shouldUseTranslation = !["gb", "us"].includes(process.env.GATSBY_LOCALE);

  // Use translation only if applicable, otherwise default to existing meta fields
  const metaDescription = shouldUseTranslation
    ? product.translations?.meta_description || product.metafields.find(m => m.key === "description_tag")?.value
    : product.metafields.find(m => m.key === "description_tag")?.value;

  const metaTitle = shouldUseTranslation
    ? product.translations?.meta_title || product.metafields.find(m => m.key === "title_tag")?.value
    : product.metafields.find(m => m.key === "title_tag")?.value;

  const updatedMetaFields = [
    ...Object.values(
      [
        ...product.metafields,
        { key: "description_tag", value: metaDescription },
        { key: "title_tag", value: metaTitle },
      ].reduce((acc, field) => ({ ...acc, [field.key]: field }), {}),
    ),
  ];
  
  return (
    <Layout
      ageGateImage={null}
      pageData={{
        page: "shop",
      }}
      template={"shop.php"}
    >
      <SEO
        data={{
          title: `${updatedMetaFields.title_tag}`,
          tags: updatedMetaFields,
        }}
      />

      <AnimateWrapper>
        <ProductDescription product={product} />
      </AnimateWrapper>

      <AnimateWrapper>
        <RecommendedGallery
          product={product}
          className={s.GalleryScroll}
          pageContext={pageContext}
          vGrid={true}
        />
      </AnimateWrapper>
    </Layout>
  )
}

export default Product
